import './LoadingBobComponent.scss';
interface ILoadingBobComponent {
	isBigLoading?: boolean;
}
const LoadingBobComponent: React.FC<ILoadingBobComponent> = ({ isBigLoading }) => {
	return (
		<div className={`loading-container ${isBigLoading ? 'big-loader' : ''}`}>
			<div className='templates-skeleton'></div>
			<div className='templates-skeleton'></div>
		</div>
	);
};
export default LoadingBobComponent;
